import { useEditorProvider } from '../editor-provider'
import { CustomButton } from './custom-button'
import { CustomImage } from './custom-image'
import { CustomVideo } from './custom-video'
import { Link } from './link'
import { ImageFile } from '../../image-file'

export const RenderElement = ({ attributes, children, element }) => {
  const { onClickAction } = useEditorProvider()
  const style = { textAlign: element.align }

  switch (element.type) {
    case 'link':
      return (
        <Link
          attributes={attributes}
          element={{ ...element, openInNewTab: true }}
          style={style}
          onClickAction={async () => {
            if (onClickAction) await onClickAction()
          }}>
          {children}
        </Link>
      )
    case 'button-custom':
      return (
        <CustomButton
          attributes={attributes}
          children={children}
          element={element}
          style={style}
          onClickAction={async () => {
            if (onClickAction) await onClickAction()
          }}
        />
      )
    case 'image-custom':
      return (
        <CustomImage
          attributes={attributes}
          children={children}
          element={element}
          style={style}
        />
      )
    case 'image-uploaded':
      return (
        <ImageFile
          fileId={element.filesId[0]}
          attributes={attributes}
          children={children}
          style={style}
        />
      )
    case 'video-custom':
      return (
        <CustomVideo
          attributes={attributes}
          children={children}
          element={element}
          style={style}
        />
      )
    case 'block-quote':
      return (
        <blockquote style={style} {...attributes}>
          {children}
        </blockquote>
      )
    case 'bulleted-list':
      return (
        <ul
          className="pl-5 list-disc"
          style={{
            ...style,
          }}
          {...attributes}>
          {children}
        </ul>
      )
    case 'numbered-list':
      return (
        <ul
          className="pl-5 list-decimal"
          style={{
            ...style,
          }}
          {...attributes}>
          {children}
        </ul>
      )
    case 'alpha-list':
      return (
        <ul
          className="pl-5 list-[lower-alpha]"
          style={{
            ...style,
          }}
          {...attributes}>
          {children}
        </ul>
      )
    case 'list-item':
      return (
        <li style={{ ...style, whiteSpace: 'pre-wrap' }} {...attributes}>
          {children}
        </li>
      )
    // Tablas. Los estilos van en clases y no en editor-view.css porque ese CSS solo
    // lo importa la toolbar, que el viewer readOnly (apps/web) no llega a montar.
    case 'table':
      return (
        <div className="my-3 w-full overflow-x-auto">
          {/*
            `w-auto max-w-full`, NO `w-full`: las columnas se ajustan al contenido y
            la tabla no se estira de más, así un valor corto alineado a la derecha
            queda junto a su fila en vez de irse al fondo. Si el contenido no cabe,
            el contenedor hace scroll horizontal.
          */}
          <table
            className="w-auto max-w-full border-collapse text-left text-inherit"
            style={style}
            {...attributes}>
            <tbody>{children}</tbody>
          </table>
        </div>
      )
    case 'table-row':
      return <tr {...attributes}>{children}</tr>
    case 'table-cell': {
      const cellStyle = { ...style, textAlign: element.align }
      const className =
        'border border-border-2-light px-3 py-2 align-top dark:border-border-2-dark'
      return element.header ? (
        <th
          className={`${className} bg-overlay-2-light font-semibold dark:bg-overlay-2-dark`}
          style={cellStyle}
          {...attributes}>
          {children}
        </th>
      ) : (
        <td className={className} style={cellStyle} {...attributes}>
          {children}
        </td>
      )
    }
    case 'heading-one':
      return (
        <span style={style} {...attributes} className={'text-[20px] font-bold'}>
          {children}
        </span>
      )
    case 'heading-two':
      return (
        <span
          style={style}
          {...attributes}
          className={'text-[18px] font-semibold'}>
          {children}
        </span>
      )
    case 'normal2lines':
      return (
        <span
          className={'h-12 overflow-hidden text-ellipsis leading-6'}
          {...attributes}
          style={{
            ...style,
          }}>
          {children}
        </span>
      )
    // `paragraph` es el bloque del editor de la versión nueva (el de la web
    // vieja emite `p`). Sin este case caía en el `default` (un <span>) y los
    // párrafos de un comentario salían pegados en la misma línea (#2812).
    case 'p':
    case 'paragraph':
      return (
        <div className="leading-normal" style={style} {...attributes}>
          {children}
        </div>
      )
    case 'pquill':
      return (
        <div className="leading-none" style={style} {...attributes}>
          {children}
        </div>
      )
    case 'div':
      return (
        <div style={style} {...attributes}>
          {children}
        </div>
      )
    default:
      return (
        <span style={style} {...attributes}>
          {children}
        </span>
      )
  }
}
